import { useForm, Controller } from "react-hook-form";
import Filter from "./Filter"
import { Autocomplete, Box, TextField } from "@mui/material";
export const FilterPet = ({ onFilter, owners = [] }) => {

    const defaultValues = {
        name: "",
        owner_id: "",
        breed: "",
        color: "",
        size: "",
        weight: "",
        age: "",
        birth_date: "",
        gender: "",
        neutered: null,
    }

    const methods = useForm({ defaultValues });

    return (
        <Filter onFilter={methods.handleSubmit(onFilter)} onClear={() => methods.reset(defaultValues)}>
            <Box display='flex' flexDirection='column' className='gap-1'>
                <TextField
                    id="name"
                    label="Nome"
                    variant="outlined"
                    name="name"
                    {...methods.register("name")}
                />

                <Controller
                    name="owner_id"
                    control={methods.control}
                    render={({ field }) => {
                        const ownerOptions = owners.map(owner => ({
                            label: owner.name,
                            value: owner.id
                        }));
                        const selectedOwner = ownerOptions.find(option => option.value === field.value);

                        return (
                            <Autocomplete
                                value={selectedOwner || null}
                                options={ownerOptions}
                                getOptionLabel={(option) => option.label || ''}
                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                onChange={(_, data) => field.onChange(data?.value || '')}
                                renderInput={(params) => <TextField {...params} label="Dono" />}
                            />
                        );
                    }}
                />
                <TextField
                    id="breed"
                    label="Raça"
                    variant="outlined"
                    name="breed"
                    {...methods.register("breed")}
                />
                <TextField
                    id="color"
                    label="Cor"
                    variant="outlined"
                    name="color"
                    {...methods.register("color")}
                />

                <Controller
                    name="size"
                    control={methods.control}
                    render={({ field }) => {
                        return (
                            <Autocomplete
                                value={field.value || null}
                                options={['pequeno', 'medio', 'grande']}
                                getOptionLabel={(option) => option || ''}
                                isOptionEqualToValue={(option, value) => option === value}
                                onChange={(_, data) => field.onChange(data || '')}
                                renderInput={(params) => <TextField {...params} label="Porte" />}
                            />
                        );
                    }}
                />

                <TextField
                    id="weight"
                    label="Peso"
                    variant="outlined"
                    name="weight"
                    {...methods.register("weight")}
                />
                <TextField
                    id="age"
                    label="Idade"
                    variant="outlined"
                    name="age"
                    {...methods.register("age")}
                />

                <Controller
                    name="birth_date"
                    control={methods.control}
                    render={({ field }) => {
                        return (
                            <TextField {...field} id="birth_date" label="Data de Nascimento" variant="outlined"
                                InputProps={{
                                    type: 'date',
                                    inputProps: {
                                        type: 'date'
                                    }
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        );
                    }}
                />

                <Controller
                    name="gender"
                    control={methods.control}
                    render={({ field }) => {
                        return (
                            <Autocomplete
                                value={field.value || null}
                                options={['macho', 'femea']}
                                getOptionLabel={(option) => option || ''}
                                isOptionEqualToValue={(option, value) => option === value}
                                onChange={(_, data) => field.onChange(data || '')}
                                renderInput={(params) => <TextField {...params} label="Sexo" />}
                            />
                        );
                    }}
                />
                <Controller
                    name="neutered"
                    control={methods.control}
                    render={({ field }) => {
                        const neuteredOptions = [
                            { label: 'Sim', value: true },
                            { label: 'Não', value: false }
                        ];
                        const selectedNeutered = neuteredOptions.find(option => option.value === field.value);

                        return (
                            <Autocomplete
                                value={selectedNeutered || null}
                                options={neuteredOptions}
                                getOptionLabel={(option) => option.label || ''}
                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                onChange={(_, data) => field.onChange(data?.value || null)}
                                renderInput={(params) => <TextField {...params} label="Castrado" />}
                            />
                        );
                    }}
                />
            </Box>
        </Filter>

    )
}